import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=ecd484b0&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=ecd484b0&prod&lang=scss"
import style1 from "./Login.vue?vue&type=style&index=1&id=ecd484b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd484b0",
  null
  
)

export default component.exports